import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import AuthCard from "~/components/auth/auth-card";
import LoginForm from "~/components/auth/login-form";

export const Route = createFileRoute("/_auth/login")({
  component: LoginComponent,
});

function LoginComponent() {
  const { t } = useTranslation("common");
  return (
    <AuthCard title={t("Auth.sign_in_title")}>
      <LoginForm />
    </AuthCard>
  );
}
